import { getAxiosBackendMubinApi } from "../../helpers/axios"

class BeneficiaryServices{

    getAll(data = {}){
        return getAxiosBackendMubinApi().get('Al_Mobeen/resources/DB/findAll', {params: data})
    }

    get(data = {}){
        return getAxiosBackendMubinApi().get('Al_Mobeen/resources/DB/person/'+data)
    }
}

export default new BeneficiaryServices()